import { useSelector } from 'react-redux';

import { useTranslate } from '@src/core/hooks';
import { DirectLinkStatus } from '@src/domains/direct-links';
import { directLinkStateSelector } from '@src/stores/directLink';

/** The message that stands in for a cart link that can no longer be bought, or `false`. */
export const useCartLinkError = (): string | false => {
  const { i18n } = useTranslate();
  const { directLink, error } = useSelector(directLinkStateSelector);

  if (directLink?.status === DirectLinkStatus.Expired || directLink?.isExpired) {
    return i18n('direct_link_expired_message');
  }
  if (directLink?.status === DirectLinkStatus.PaymentComplete) {
    return i18n('direct_link_finished_sale_message');
  }
  if (directLink?.status === DirectLinkStatus.Canceled) {
    return i18n('direct_link_cancelled_message');
  }

  return error || false;
};

export default useCartLinkError;
